import svgjs from 'svg.js';

export enum GaugeElementId {
   BODY = 'BODY',
   CENTER = 'CENTER',
   CENTER_LABEL = 'CENTER_LABEL',
   UPPER_BOUND_LABEL = 'UPPER_BOUND_LABEL',
   LOWER_BOUND_LABEL = 'LOWER_BOUND_LABEL',
   ARROW_GROUP = 'ARROW_GROUP',
   ARROW = 'ARROW',
   LEFT_VERTICAL_LABEL = 'LEFT_VERTICAL_LABEL',
   RIGHT_HORIZONTAL_LABEL = 'RIGHT_HORIZONTAL_LABEL',
   CIRCULAR_BAR_SECTION = 'CIRCULAR_BAR_SECTION',
   CIRCULAR_BAR_BORDER = 'CIRCULAR_BAR_BORDER'
}

export interface GaugeCoordinates {
   x: number;
   y: number;
}

export const HALF_CIRCLE_DEGREES = 180;
export const QUARTER_CIRCLE_DEGREES: number = HALF_CIRCLE_DEGREES / 2;
export const GAUGE_CENTER_COORDINATES: GaugeCoordinates = {
   x: 50,
   y: 50
};
export const GAUGE_STROKE_DEFAULT_COLOR = '#222222';

export const getValueBasedOnBounds = (value: number,
                                      lowerBound: number,
                                      upperBound: number): number => {
   if (value < lowerBound) {
      return lowerBound;
   }
   else if (value > upperBound) {
      return upperBound;
   }

   return value;
};

export const formatLabelIdAndId = (labelId: GaugeElementId, svgId: string): string => {
   return `${GaugeElementId[labelId]}-${svgId}`;
};

export const updateLabelTextById = (id: string, label: string | number): void => {
   const element = svgjs.get(id) as any;

   element && element.text(label.toString());
};

export const updateLabelColorById = (id: string, color: string): void => {
   const element = svgjs.get(id) as any;

   element && element.font('fill', color);
};

export const formatLabel = (value: number | string,
                            prePend?: string,
                            postPend?: string): string => {
   return `${prePend || ''}${value}${postPend || ''}`;
};
